import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";

import { ResidencesControl } from "./ResidencesControl";
import { ResidencesSummaryControl } from "./ResidencesSummaryControl";

/* eslint-disable react-hooks/rules-of-hooks */
function _ResidencesControl(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <ResidencesSummaryControl {...props} />;
  }

  return <ResidencesControl {...props} />;
}
/* eslint-enable react-hooks/rules-of-hooks */

/**
 * ResidencesControlRenderer is a renderer for the ResidencesControl component.
 * It determines whether to render the summary or detailed version of the control
 * based on the context provided by CascadiaJsonFormContext.
 *
 * @deprecated This component is deprecated and will be removed in future releases.
 * Please use ResidencesArrayControlRenderer instead.
 *
 * @see {@link ResidencesControl} for the detailed control component.
 */
export const ResidencesControlRenderer =
  withJsonFormsArrayControlProps(_ResidencesControl);
